function toggleShowHidePassword(e) {
  const toggle = e.target;
  const passwordInput = toggle.previousElementSibling;

  if (passwordInput.type === 'password') {
    toggle.innerHTML = '<i class="fas fa-eye"></i>';
    passwordInput.type = 'text';
  } else {
    toggle.innerHTML = '<i class="fas fa-eye-slash"></i>';
    passwordInput.type = 'password';
  }
}

export function initializePasswordShowHide() {
  const passwordToggles = Array.from(
    document.querySelectorAll('.password-show-hide')
  );
  passwordToggles.forEach((passwordToggle) => {
    passwordToggle.addEventListener('click', (e) => toggleShowHidePassword(e));
  });
}
